"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ContentLine_1 = require("../../contentLine/ContentLine");
var Price_1 = require("../../../../../common/components/prices/price/Price");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var react_intl_1 = require("react-intl");
var reservationLabelStyles_1 = require("./reservationLabelStyles");
var client_1 = require("@apollo/client");
var cache_1 = require("../../../../../common/graphql/cache");
var JourneyTypes_1 = require("../../../../../../../../common/enum/JourneyTypes");
var ReservationDetail = function (_a) {
    var totalAmount = _a.totalAmount, currency = _a.currency;
    var intl = react_intl_1.useIntl();
    var styles = reservationLabelStyles_1.default();
    var journeyType = client_1.useReactiveVar(cache_1.activeJourneyType);
    var reservationFee = parseInt(intl
        .formatMessage({
        id: 'trans__checkout__confirmation_page__summary__reservation_reservation_fee',
    })
        .substring(1)
        .replace(/[^0-9]+/g, ''));
    var outStandingBalance = totalAmount - (reservationFee || 0);
    if (journeyType === JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP) {
        return null;
    }
    return (<core_1.Box data-test={'summary:car_details:reservation-details'}>
      <ContentLine_1.default className={styles.reservationAmount} mainContent={<core_1.Typography variant="subtitle1" component="span" className={styles.label} data-test={'summary:car_details:reservation_details:reservation-amount-label'}>
            <Translation_1.default id={'trans__fincalc__cash_breakdown__refundable_reservation_fee_label'}/>
          </core_1.Typography>} secondaryContent={<>
            <core_1.Typography variant="subtitle1" component="span" className={styles.label}>
              {'- '}
            </core_1.Typography>
            <Price_1.default className={styles.label} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} price={reservationFee} currency={currency} dataTest={'summary:car_details:reservation_details:reservation-amount'}/>
          </>}/>
      <ContentLine_1.default className={styles.outStandingBalance} mainContent={<core_1.Typography variant="subtitle1" component="span" className={styles.boldLabel} data-test={'summary:car_details:reservation_details:out-standing-balance-label'}>
            <Translation_1.default id={'trans__checkout__vehicle_details__outstanding_balance'}/>
          </core_1.Typography>} secondaryContent={<Price_1.default className={styles.boldLabel} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} price={outStandingBalance} currency={currency} dataTest={'summary:car_details:reservation_details:out-standing-balance'}/>}/>
    </core_1.Box>);
};
exports.default = ReservationDetail;
